<template>
  <BoxCard class="performance-summary-widget mb-2">
    <template #header>
      <div class="relative full-width">
        <h4>Performance Summary</h4>
        <div class="tooltip-icon">
          <Tooltip>
            <template #trigger>
              <i class="fas fa-info-circle"></i>
            </template>
            <template #tooltip>
              <div><MetricsTooltipMobile /></div>
            </template>
          </Tooltip>
        </div>
      </div>
    </template>
    <template #body>
      <div v-if="data" class="performance-summary-container">
        <div class="performance-row-container">
          <ComparisonWidget
            header="JOB REVENUE"
            :base="data.base.jobs_revenue"
            :comparison="data.comparison.jobs_revenue"
            type="currency"
          />
          <ComparisonWidget
            header="OPPORTUNITY AVG"
            :base="data.base.jobs_revenue_average"
            :comparison="data.comparison.jobs_revenue_average"
            type="currency"
          />
          <ComparisonWidget
            header="MEMBERSHIPS SOLD"
            :base="data.base.memberships_sold"
            :comparison="data.comparison.memberships_sold"
          />
          <ComparisonWidget
            header="MEMBERSHIP WIN RATE (MWR)"
            :base="data.base.memberships_win_rate"
            :comparison="data.comparison.memberships_win_rate"
          >
            <template #body>
              <DoughnutComparisonWidget
                header="MEMBERSHIP WIN RATE (MWR)"
                :base="data.base.memberships_win_rate"
                :comparison="data.comparison.memberships_win_rate"
              />
            </template>
          </ComparisonWidget>
        </div>
        <div class="performance-row-container">
          <ComparisonWidget
            header="OPPORTUNITIES"
            :base="data.base.opportunities_complete"
            :comparison="data.comparison.opportunities_complete"
          />
          <ComparisonWidget
            header="JOBS SOLD"
            :base="data.base.jobs_sold"
            :comparison="data.comparison.jobs_sold"
          />
          <ComparisonWidget
            header="DENIED QUOTES"
            :base="data.base.quotes_denied"
            :comparison="data.comparison.quotes_denied"
            invert-color
          />
          <ComparisonWidget
            header="JOBS CLOSE RATE"
            :base="data.base.jobs_win_rate"
            :comparison="data.comparison.jobs_win_rate"
          >
            <template #body>
              <DoughnutComparisonWidget
                header="JOBS CLOSE RATE"
                :base="data.base.jobs_win_rate"
                :comparison="data.comparison.jobs_win_rate"
              />
            </template>
          </ComparisonWidget>
        </div>
      </div>
      <img v-else class="skeleton" :src="PerformanceSummarySkeletonImg" />
    </template>
  </BoxCard>
</template>

<script>
import { mapState } from "vuex";

import Tooltip from "@/components/Tooltip.vue";
import PerformanceSummarySkeletonImg from "@/images/performance_summary_skeleton.png";
import { breakpoints } from "@/mixins";
import BoxCard from "../components/BoxCard.vue";
import MetricsTooltipMobile from "./MetricsTooltipMobile.vue";
import ComparisonWidget from "./Widgets/ComparisonWidget.vue";
import DoughnutComparisonWidget from "./Widgets/DoughnutComparisonWidget.vue";

export default {
  components: {
    ComparisonWidget,
    DoughnutComparisonWidget,
    BoxCard,
    MetricsTooltipMobile,
    Tooltip
  },
  data() {
    return {
      PerformanceSummarySkeletonImg
    };
  },
  computed: {
    ...mapState({
      dashboardFilters: "dashboardFilters",
      data: function ({ dashboardData }) {
        return dashboardData.summary ? dashboardData.summary : null;
      }
    })
  },
  methods: {
    isMobileScreenSize() {
      return breakpoints().sm;
    }
  }
};
</script>

<style lang="scss" scoped>
.performance-summary-container {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
}

.performance-row-container {
  display: flex;
  flex-direction: row;
  height: 50%;
  width: 100%;
  flex-wrap: wrap;
}
.skeleton {
  margin: 0 auto;
  display: block;
  height: 215px;
}

.tooltip-icon {
  position: absolute;
  right: 0px;
  top: -2px;
}
</style>
